  <template>
  <div>
    <div class="Banner">
      <img src="../../assets/qwwlwkxsjfw_banner.png" alt="">
    </div>
    <div class="container">
      <div class="title">
        <h1>
          全网物联网卡销售及服务
        </h1>
        <aside>
          Whole network IoT card sales and services
        </aside>
      </div>
      <div class="row">
        <div class="col-sm-6 col-xs-12">
          <h4>悦享互联提供移动、联通、电信三大运营商的物联网卡代理销售业务及流量卡流量管理业务。自主研发的流量卡管理平台目前已经管理超过100万张流量卡。其中包括美团、人民数字、福田汽车等不同行业应用场景的大客户。</h4>
          <p>
            流量卡平台支持：
          </p>
          <aside class="text">
            三大运营商物联网卡统一展现 <br>
            流量池管理与监控 <br>
            单卡流量与流量池的信息预警及自动化 <br>
            设备的IMEI号、位置信息获取 <br>
            流量用量与趋势报表分析 <br>
            流量费用对账与BI商业智能 <br>
            物联网卡用户多租户管理 <br>
            物联网卡自助停开机 <br>
            基于PC端和微信平台的充值缴费 <br>
            物联网流量卡二次实名认证 <br>
            流量限速与黑白名单 <br>
            平台与设备间的短信下发 <br>
            计费周期到期期限查询 <br>
          </aside>
        </div>
        <div class="col-sm-6 col-xs-12">
          <img src="../../assets/Sales_service_pic01.jpg" style="margin-bottom: 30px" alt="">
          <img src="../../assets/Sales_service_pic02.jpg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <Footer />
  </div>
</template>

<script>
  import Footer from '../../components/Footer'
  export default {
    name: 'Introduction',
    components: {
      Footer
    },
    props: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img{
  width: 100%;
}
.Banner {
  margin-bottom: 4rem;
}
h1 {
  font-size: 4.6rem;
  color: #fe9901;
}
aside {
  font-size: 1.6rem;
  color: #999;
  text-transform: uppercase;
}
.title {
  padding-left: 30px;
  border-left: 1px solid #ccc;
  margin-bottom: 4rem;
}
  h4 {
    color: #333;
    font-size: 1.8rem;
    text-indent: 30px;
    line-height: 35px;
    margin-bottom: 25px;
    font-weight: normal;
  }
  p {
    color: #333;
    font-size: 1.8rem;
    line-height: 35px;
    margin-bottom: 0px;
    font-weight: bold;
  }
  .text {
    color: #666;
    font-size: 1.8rem;
    line-height: 35px;
    margin-bottom: 0px;
    font-weight: normal;
    padding-left: 30px;
  }
</style>
